import React from 'react'
import cx from 'classnames'

interface TableCellProps {
  children: React.ReactNode
  align?: 'left' | 'center' | 'right'
  gap?: 'small' | 'medium'
  className?: string
}

const TableCellActions = ({
  children,
  align = 'left',
  gap = 'medium',
  className,
}: TableCellProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <td
      className={cx('table-cell-actions', align, gap, className)}
      onClick={handleClick}
    >
      {children}
    </td>
  )
}

export default TableCellActions
